import { FormControlSearchableSelectAPI } from "../../organisms/Form";
import { MountedQuickCreate } from "./MountedQuickCreate";
import { useQuickCreateSelect } from "./useQuickCreateSelect";

/**
 * Searchable select whose first option opens a Create * drawer and selects the new id.
 *
 * @param {object} props
 * @param {string} props.name Formik field name.
 * @param {*} props.Drawer Quick-create drawer component.
 * @param {string} props.createLabel Dropdown create-row label.
 * @param {string=} props.context Select context, default master.
 * @param {boolean=} props.refetchOnOpen Live-synced selects stay false.
 * @param {function(number): void=} props.onCreated Extra handler after select.
 * @return {*}
 */
export const QuickCreateSelect = ({
  name,
  Drawer,
  createLabel,
  context = "master",
  refetchOnOpen = false,
  onCreated,
  ...selectProps
}) => {
  const { setOpen, drawerProps } = useQuickCreateSelect(name, context, onCreated);

  if (!Drawer) {
    throw new Error("QuickCreateSelect requires a Drawer");
  }

  return (
    <>
      <FormControlSearchableSelectAPI
        name={name}
        context={context}
        refetchOnOpen={refetchOnOpen}
        createLabel={createLabel}
        onCreate={() => setOpen(true)}
        {...selectProps}
      />
      <MountedQuickCreate Drawer={Drawer} {...drawerProps} />
    </>
  );
};
